import { createFileRoute } from '@tanstack/react-router';
import { AutomationPageView } from '@/components/marketing/AutomationPage';
import { automationHead } from '@/content/aiAutomation';
export const Route = createFileRoute('/ai-automation/company-brain')({head: () => automationHead('brain'), component: CompanyBrainPage});
function CompanyBrainPage() { return <AutomationPageView pageKey="brain" />; }
